module.exports = __webpack_public_path__ + "static/media/value-prop-icon-1.9d6346ce.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/value-prop-icon-1.svg
// module id = 2660
// module chunks = 0